import script from "./PurchaseListPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PurchaseListPage.vue?vue&type=script&lang=ts&setup=true"

import "./PurchaseListPage.vue?vue&type=style&index=0&id=459826b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459826b2"]])

export default __exports__